'use client';

import { Flex, Link, For } from "@chakra-ui/react";

export default function NavMenu({ menu }) {
  return (
    <Flex pt={{ base: '4', sm: '0' }}>
      <For each={menu}>
        {item => (
          <Link
            href={item.href}
            key={item.label}
            title={item.label}
            display="inline-block"
            px="2"
            py="2"
            mx="1"
            fontWeight="300"
            fontSize="1.1em"
            color="white"
            _hover={{ color: 'blue.500' }}
          >
            {item.label}
          </Link>
        )}
      </For>
    </Flex>
  )
}
